'use strict';

var EFC = window.EFC = (window.EFC || {});
EFC.breakpoints = { laptop: 1024 }

window.addEventListener('DOMContentLoaded', function(){

  /* Navigation Menu/Search Opening/Closing
  ------------------------------------------------------ */

  var searchButton = document.getElementById('searchsubmit'),
      searchForm   = document.getElementById('searchform'),
      searchField  = document.getElementById('s'),
      primaryNav   = document.getElementById('primaryNav');

  var openSearch = EFC.openSearch = function() {
    searchForm.classList.add('open');
    searchButton.setAttribute('aria-expanded', 'true');
  }

  var closeSearch = EFC.closeSearch = function() {
    searchForm.classList.remove('open');
    searchButton.setAttribute('aria-expanded', 'false');
  }

  searchButton.addEventListener('click', function(e) {
    if (!searchForm.classList.contains('open')) {
      e.preventDefault();
      openSearch();
      searchField.focus();
    }
  });

  searchField.addEventListener('focus', function(e) {
    openSearch();
  });


  /* Resource centre lightboxes
  ------------------------------------------------------ */

  /* -- Video lightbox -- */
  var embedLinks = document.querySelectorAll('a[embed]');
  for (var i = embedLinks.length - 1; i >= 0; i--) {
    embedLinks[i].addEventListener('click', spawnLightbox);
  }

  function spawnLightbox(e) {
    e.preventDefault();

    var url = e.currentTarget.attributes['embed'].value;
    var boxWrapper = document.createElement('div'),
        boxInner = document.createElement('div'),
        boxClose = document.createElement('a'),
        iFrame = document.createElement('iframe');

    boxWrapper.classList.add('video-lightbox__wrapper');
    boxInner.classList.add('video-lightbox');
    boxClose.classList.add('video-lightbox__close');
    boxClose.href = '#';
    iFrame.classList.add('video-lightbox__embed');
    iFrame.src = url;

    boxInner.appendChild(boxClose);
    boxInner.appendChild(iFrame);
    boxWrapper.appendChild(boxInner);
    document.body.appendChild(boxWrapper) && boxWrapper.classList.add('open');

    function closeLightbox(e) {
      if (e.currentTarget === boxWrapper || e.currentTarget === boxClose) {
        e.preventDefault();
        e.stopPropagation();
        document.body.removeChild(boxWrapper);
      }
    }

    boxWrapper.addEventListener('click', closeLightbox);
    boxClose.addEventListener('click', closeLightbox);
  }

  /* -- PhotoSwipe Galleries -- */
  var galleryData = document.getElementById('pswpData');

  if (galleryData) {
    galleryData = JSON.parse(galleryData.innerText);
    var galleries = [],
        galleryOpts = {
          getThumbBoundsFn: false,
          showHideOpacityTrue: true
        },
        galleryTriggers = document.querySelectorAll('a[gallery]'),
        pswpEl = document.querySelectorAll('.pswp')[0];

    for (var i = galleryData.length - 1; i >= 0; i--) {
      galleryTriggers[i].addEventListener('click', function(e){
        e.preventDefault();
        var i = parseInt(e.currentTarget.attributes.gallery.value);
        var gallery = new PhotoSwipe(pswpEl, PhotoSwipeUI_Default, galleryData[i], galleryOpts);
        gallery.init();
      });
    }
  }


  /* Tableau Navigation
  ------------------------------------------------------ */

  function tableauHashHandler() {
    if (location.hash.substr(1,7) != 'tableau') return;
    
    var prevNav = document.querySelectorAll('a.tableau_link.current')[0],
        curNav  = document.querySelectorAll('a[href="'+location.hash+'"]')[0],
        prevTab = document.querySelectorAll('.tableau_article.open')[0],
        curTab  = document.querySelectorAll('.tableau_article'+location.hash)[0];

    prevNav && prevNav.classList.remove('current');
    curNav  && curNav. classList.add('current');
    prevTab && prevTab.classList.remove('open');
    curTab  && curTab. classList.add('open');

    window.scrollTo(0, curTab.offsetTop - primaryNav.offsetHeight);

    if (ga)
      ga('send', 'pageview', {'page': location.pathname + location.hash});
  }
  window.addEventListener('hashchange', tableauHashHandler);

  if (location.hash) tableauHashHandler();

  function suppressHashJumps(e) {
    e.preventDefault();
    location.hash = e.target.attributes.href.value;
  }
  var hashTriggers = document.querySelectorAll('[href^="#tableau"]');
  for (var i = hashTriggers.length - 1; i >= 0; i--) {
    hashTriggers[i].addEventListener('click', suppressHashJumps);
  }

  /* Partial `position: sticky` polyfill
  ------------------------------------------------------ */

  /**
   * Test for native `position: sticky` support
   *
   * @return     {boolean}
   */
  function browserHasStickySupport() {
    var testNode = document.createElement('div');

    return ['', '-webkit-', '-moz-', '-ms-'].some(function(prefix) {
      try {
        testNode.style.position = prefix + 'sticky';
        return testNode.style.position != '';
      }
      catch(e) {
        return false;
      }
    });
  }

  var stickyElements = document.querySelectorAll( browserHasStickySupport() ? '[na-sticky="force"]' : '[na-sticky]' );

  if (stickyElements.length) {

    // Convert NodeList to Array for the helper methods
    stickyElements = [].slice.call(stickyElements);

    var stickyTicking = false,
        stickies = stickyElements.map(function(el) {
          return {
            el: el,
            parentBox: el.parentElement.getBoundingClientRect()
          };
        });

    function stickyUpdate() {

      for (var i in stickies) {
        var sticky = stickies[i];

        if ( sticky.parentBox.top > emValue() * 7 ) {
          // At top of page, don't do anything yet
          sticky.el.removeAttribute('na-sticky-status');
        }
        else if ( (sticky.parentBox.height + sticky.parentBox.top - (emValue() * 7)) < sticky.el.scrollHeight ) {
          // At bottom of page, stick to bottom
          sticky.el.setAttribute('na-sticky-status', 'bottom');
        }
        else {
          // In between, make it stick!
          sticky.el.setAttribute('na-sticky-status', 'stuck');
        }
      }

      stickyTicking = false;
    }

    function requestStickyUpdate() {
      if (!stickyTicking) {
        for (var i in stickies) {
          stickies[i].parentBox = stickies[i].el.parentElement.getBoundingClientRect();
        }
        requestAnimationFrame(stickyUpdate);
      }

      stickyTicking = true;
    }

    function stickyScroll() {
      requestStickyUpdate();
    }

    function emValue(el) {
      el = el || document.body;
      return Number(getComputedStyle(el).fontSize.match(/(\d+(\.\d+)?)px$/)[1]);
    }

    window.addEventListener('scroll', stickyScroll);
  }
  
  setupLoadMoreHandler();
});

function setupLoadMoreHandler() {
  var loadMoreButton = document.querySelector('.load-more');
  loadMoreButton && loadMoreButton.addEventListener('click', function(e) {
    var url = this.href;
    var restUrl = this.dataset.loadMore;
    
    if (!url) { window.location = url; }
    
    fetch(restUrl)
      .then(function(response) { return response.json(); })
      .then(function(response) {
        if (response.status !== 'success') {
          error_log("Unsuccessful response", response);
          window.location = url;
        }
        
        var data = response.data;
        var container = document.querySelector('.postBox-container');
        container.innerHTML = container.innerHTML + data.postHtml;
        
        if (data.nextPagedUrl) {
          loadMoreButton.href = data.nextPagedUrl;
          loadMoreButton.dataset.loadMore = data.nextRestUrl;
        }
        else {
          loadMoreButton.remove();
        }
      })
      .catch(function(err) {
        console.error("Error fetching ", url, err);
        window.location = url;
      });
      
    e.preventDefault();
  });
}

function efc_setScrolledFromTopClass() {
  jQuery('body').toggleClass('scrolledFromTop', (window.pageYOffset > 1));
}

window.addEventListener('scroll', efc_setScrolledFromTopClass);

(function($) {
  function init() {
    $('.noticeBanner__close').on('click', function(e) {
      e.preventDefault();
      Cookies.set('efc-bannerClosed', 1); 
      $('body').removeClass('with-notice-banner');
    })
    
    if (Cookies.get('efc-bannerClosed') == 1) {
      $('body').removeClass('with-notice-banner');
    }
  }
  
  $(init);
})(jQuery);


/**
 * @return a function for the "keydown" event that listens for tabs and automatically wraps tab from the firstFocusable to the lastFocusable.
 * Note that we'd normally use keyup handlers to listen for keys, but Tab specifically takes effect on a keydown
 * 
 * Parameters can be elements or arrays.  If they are arrays, only the first visible element will be treated.
 */
EFC.createFocusTrapKeyDownListener = function(fromEl, toEl) {
  return function(e) {
    if (EFC.createFocusTrapKeyDownListener.hasRunThisTick) { return; }
    if (e.key !== 'Tab') { return; }
    var nextElement;
    var testElement = null;
    var elementFromElOrArray = function(elOrArray) {
      if (Array.isArray(elOrArray)) {
        var eligibleElements = elOrArray.filter(function (el) { return el && el.offsetParent !== null && !el.getAttribute('aria-hidden'); });
        return (eligibleElements.length > 0) ? eligibleElements[0] : null;
      }
      else {
        return elOrArray;
      }
    };
    
    var visibleToEl = elementFromElOrArray(toEl);
    var visibleFromEl = elementFromElOrArray(fromEl);

    if (e.shiftKey) {
      if (document.activeElement === visibleToEl) {
        nextElement = visibleFromEl;
      }
    }
    else {
      if (document.activeElement === visibleFromEl) {
        nextElement = visibleToEl;
      }
    }

    
    if (nextElement) {
      nextElement.focus();
      e.preventDefault();
      EFC.createFocusTrapKeyDownListener.hasRunThisTick = true;
      window.setTimeout(function() { EFC.createFocusTrapKeyDownListener.hasRunThisTick = false; }, 0);
    }
  }
}  
EFC.createFocusTrapKeyDownListener.hasRunThisTick = false;
